
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"x":"-28.1%","y":"-21.9%","width":"156.2%","height":"156.2%","filterUnits":"objectBoundingBox","id":"id-27a"}},[_c('feMorphology',{attrs:{"radius":"1","operator":"dilate","in":"SourceAlpha","result":"shadowSpreadOuter1"}}),_c('feOffset',{attrs:{"dy":"1","in":"shadowSpreadOuter1","result":"shadowOffsetOuter1"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"1","in":"shadowOffsetOuter1","result":"shadowBlurOuter1"}}),_c('feComposite',{attrs:{"in":"shadowBlurOuter1","in2":"SourceAlpha","operator":"out","result":"shadowBlurOuter1"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0","in":"shadowBlurOuter1"}})]),_c('path',{attrs:{"d":"M12 4a1 1 0 011 1v6h6a1 1 0 010 2h-6v6a1 1 0 01-2 0v-6H5a1 1 0 010-2h6V5a1 1 0 011-1z","id":"id-28b"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('use',{attrs:{"fill":"#000","filter":"url(#id-27a)","xlink:href":"#id-28b"}}),_c('path',{attrs:{"stroke-opacity":".04","stroke":"#000","d":"M12 3.5l.153.008A1.495 1.495 0 0113.5 5h0v5.5H19c.414 0 .79.168 1.06.44a1.495 1.495 0 010 2.121c-.27.271-.646.439-1.06.439h0-5.5V19c0 .414-.168.79-.44 1.06a1.495 1.495 0 01-2.121 0A1.495 1.495 0 0110.5 19h0v-5.5H5c-.414 0-.79-.168-1.06-.44A1.495 1.495 0 013.5 12c0-.414.168-.79.44-1.06.27-.272.646-.44 1.06-.44h5.5V5c0-.414.168-.79.44-1.06.27-.272.646-.44 1.06-.44h0z","fill":"#FFF"}})])])
          )
        }
      }
    